import axios from 'axios';
import {cnxAPI, notifica, show_ldr, getUser} from '../requests/utils';

var a = null, b = null;

//Función para obtener las notificaciones
function getNotifications(_callback){
    var usr = getUser(),
        json = {idCandidato: usr.idCandidato};
    show_ldr(true);
    axios({
        method: 'post',
        url: cnxAPI + 'Candidato/GetNotificaCandidatos',
        headers: {'Content-Type': 'application/json; charset=utf-8', 'X-Requested-With':'XMLHttpRequest'},
        data: json
    }).then(function (response) {
        show_ldr(false);
        if(response.status !== 200){
            notifica('warning', response.data.message, 'Alerta!');
        }else{
            a = response.data;
        }
    }).catch(function (error) {
        notifica('danger', error, 'Error');
    }).then(() => _callback(a));
}

//Función para obtener las notificaciones
function deleteNotification(_callback){
    var usr = getUser(),
        idNotif = document.getElementById('lbl_util'),
        json = {idCandidato: usr.idCandidato , idNotificaCandidato: idNotif.innerText};
    show_ldr(true);
    axios({
        method: 'post',
        url: cnxAPI + 'Candidato/DeleteNotificaCandidatos',
        headers: {'Content-Type': 'application/json; charset=utf-8', 'X-Requested-With':'XMLHttpRequest'},
        data: json
    }).then(function (response) {
      
        show_ldr(false);
        if(response.status !== 200){
            notifica('warning', response.data.message, 'Alerta!');
        }else{
            b = response.data;
        }
    }).catch(function (error) {
        notifica('danger', error, 'Error');
    }).then(() => _callback(b));
}

export {getNotifications, deleteNotification};